export const authMessages = {
  "auth.shell.eyebrow": "A place for your reading life",
  "auth.shell.title": "Every book leaves a small mark.",
  "auth.shell.description":
    "Keep your library, reading rhythm, and next chapter together in one quiet place.",
  "auth.carousel.label": "Celsus features",
  "auth.carousel.chooseFeature": "Choose a feature",
  "auth.carousel.previous": "Previous feature",
  "auth.carousel.next": "Next feature",
  "auth.carousel.pause": "Pause feature carousel",
  "auth.carousel.play": "Play feature carousel",
  "auth.carousel.library.eyebrow": "Your library",
  "auth.carousel.library.title": "Every book, beautifully organized.",
  "auth.carousel.library.description":
    "Build thoughtful shelves, track what you own, and keep your next reads close at hand.",
  "auth.carousel.progress.eyebrow": "Reading insights",
  "auth.carousel.progress.title": "See the rhythm behind your reading.",
  "auth.carousel.progress.description":
    "Log sessions, follow goals, and turn everyday reading into progress you can see.",
  "auth.carousel.discover.eyebrow": "Discover together",
  "auth.carousel.discover.title": "Find the book that comes next.",
  "auth.carousel.discover.description":
    "Explore recommendations and share thoughtful reviews with a community of readers.",
  "auth.password.show": "Show {label}",
  "auth.password.hide": "Hide {label}",
  "auth.password.requirements": "Password must include:",
  "auth.password.requirement.length": "At least 8 characters",
  "auth.password.requirement.lowercase": "One lowercase letter",
  "auth.password.requirement.uppercase": "One uppercase letter",
  "auth.password.requirement.number": "One number",
  "auth.password.requirement.special": "One special character",
  "auth.session.checking": "Checking your session",
  "auth.recovery.eyebrow": "Account recovery",
  "auth.recovery.title": "Reset your password",
  "auth.recovery.description":
    "Enter your account email. For privacy, the result is the same whether or not an account exists.",
  "auth.recovery.sent":
    "If an account uses that address, a private recovery link is on its way.",
  "auth.recovery.checkEmail": "Check your email",
  "auth.recovery.requestFailed": "Request failed",
  "auth.email": "Email address",
  "auth.recovery.send": "Send recovery link",
  "auth.returnToSignIn": "Return to sign in",
  "auth.reset.title": "Choose a new password",
  "auth.reset.description": "This private link can be used once and expires shortly.",
  "auth.reset.confirmationMismatch": "The password confirmation does not match.",
  "auth.reset.success":
    "Your password has been reset and existing sessions were signed out.",
  "auth.reset.invalidLink": "Invalid link",
  "auth.reset.missingToken": "This recovery link is missing its token.",
  "auth.reset.successTitle": "Password reset",
  "auth.reset.failureTitle": "Password not reset",
  "auth.reset.newPassword": "New password",
  "auth.reset.confirmPassword": "Confirm password",
  "auth.reset.submit": "Reset password",
  "auth.verify.eyebrow": "Email verification",
  "auth.verify.title": "Confirm your address",
  "auth.verify.description":
    "Verification protects account recovery and security notices.",
  "auth.verify.progress": "Verifying your email address…",
  "auth.verify.missingToken": "This verification link is missing its token.",
  "auth.verify.success": "Your email is verified. You can now sign in.",
  "auth.verify.failed": "Verification failed",
  "auth.verify.status": "Verification status",
  "auth.verify.continue": "Continue to sign in",
} as const;
